import React, { useState } from "react";
import { message, Spin } from "antd";
import { useHistory } from "react-router-dom";
import { routes } from "../../routes/Routes";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import Login from "../../components/Login/Login";
import {COMPLIANCE_ADMIN_ROLE_ID} from "../../constants/DataConstants";

const ComplianceAdminLogin = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Email: values.email,
                Password: values.password,
                IsBanker: "Compliance",
                RoleId: COMPLIANCE_ADMIN_ROLE_ID
            };
            const res = await _BankerService.bankerLogin(reqObj);
            if (res?.data?.IsSuccess) {
                localStorage.setItem("IsLoanofficerFlag", JSON.stringify(false));
                localStorage.setItem("IsBankAdminFlag", JSON.stringify(false));
                localStorage.setItem("BankerEmailId", res?.data?.Obj?.Email);
                localStorage.setItem("BankerId", res?.data?.Obj?.Id);
                localStorage.setItem("BankerFirstName", res?.data?.Obj?.FirstName);
                localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
                localStorage.setItem("listUserRoles", JSON.stringify(res?.data?.Obj?.listUserRoles));
                localStorage.setItem("Password", values.password);

                history.push(routes.complianceadmindashboard.path);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.log(err);
            message.error(COMMON_ERROR_MSG);
        } finally {
            setLoading(false);
        }
    };

    const forgotPassword = () => {
        history.push(routes.forgotBankerLoginPasswordSendOTP.path);
    };

    const applicantLogin = () => {
        history.push(routes.registeredEmail.path);
    };

    const bankerLogin = () => {
        history.push(routes.accountLogin.path);
    };

    const bankerAdminLogin = () => {
        history.push(routes.bankAdminLogin.path);
    };

    const loanOfficerLogin = () => {
        history.push(routes.accountLoginForLoanOfficer.path);
    };

    const complianceAdminLogin = () => {
        history.push(routes.complianceAdminLogin.path);
    };

    return (
        <Spin spinning={loading}>
            <Login
                role="Compliance Administrator"
                title="Compliance Admin Portal"
                onFinishHandle={onFinish}
                forgotPassword={forgotPassword}
                bankerLogin={bankerLogin}
                bankerAdminLogin={bankerAdminLogin}
                loanOfficerLogin={loanOfficerLogin}
                complianceAdminLogin={complianceAdminLogin}
                isNewAccountCreateFlag={false}
                applicantLogin={applicantLogin}
            />
        </Spin>
    );
};

export default ComplianceAdminLogin;